<template>
  <component :is="layout">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </component>
</template>

<script>
  const defaultLayout = 'default'

  export default {
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
